import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { Check } from '@mui/icons-material';
import { format } from 'date-fns';

const COLOR_MAP = {
    green:  { bg: '#33B679',          text: '#fff',    border: 'none' },
    blue:   { bg: 'rgba(0,0,0,0.55)', text: '#e8e8e8', border: '2px solid #4a90d9' },
    purple: { bg: '#9b59b6',          text: '#fff',    border: 'none' },
};
const PAUSED_STYLE = { bg: '#2a2a2a', text: '#aaa', border: '2px solid #f39c12' };

const EventBlock = ({ event, top, height, dayIdx, onClick, onDone }) => {
    const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
        id: event.id,
        disabled: event.is_done,
        data: { event, originalDayIdx: dayIdx, originalTopPx: top },
    });

    const c       = event.is_paused ? PAUSED_STYLE : (COLOR_MAP[event.color_type] ?? COLOR_MAP.green);
    const compact = height < 42;

    return (
        <div
            ref={setNodeRef}
            {...listeners}
            {...attributes}
            onClick={e => { e.stopPropagation(); if (!isDragging) onClick(); }}
            style={{
                position: 'absolute',
                top,
                left: 2,
                right: 2,
                height: Math.max(height, 24),
                background: c.bg,
                border: c.border,
                borderRadius: 5,
                padding: compact ? '2px 6px' : '4px 6px',
                cursor: isDragging ? 'grabbing' : 'grab',
                overflow: 'hidden',
                opacity: isDragging ? 0.25 : (event.is_done ? 0.45 : 1),
                zIndex: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                userSelect: 'none',
                boxShadow: '0 1px 4px rgba(0,0,0,0.4)',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <span style={{
                    color: c.text, fontSize: 11, fontWeight: 600,
                    textDecoration: event.is_done ? 'line-through' : 'none',
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                }}>
                    {event.title}
                </span>
                {event.lesson_number && (
                    <span style={{
                        marginLeft: 'auto', fontSize: 9, color: c.text,
                        opacity: 0.55, fontWeight: 700, flexShrink: 0,
                    }}>
                        #{event.lesson_number}
                    </span>
                )}
            </div>

            {!compact && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ color: c.text, fontSize: 10, opacity: 0.8 }}>
                        {format(new Date(event.start_time), 'HH:mm')} – {format(new Date(event.end_time), 'HH:mm')}
                    </span>
                    {!event.is_done && (
                        <button
                            onPointerDown={e => e.stopPropagation()}
                            onClick={e => { e.stopPropagation(); onDone(event); }}
                            style={{
                                background: 'rgba(255,255,255,0.2)', border: 'none',
                                borderRadius: 3, cursor: 'pointer', color: c.text,
                                padding: '1px 3px', display: 'flex', alignItems: 'center',
                            }}
                        >
                            <Check style={{ fontSize: 11 }} />
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default EventBlock;
